module.exports = __webpack_public_path__ + "assets/img/100901.9d4da3ec.svg";